import { useTranslation } from 'react-i18next';
import { Button } from '../Button';
import styles from './AreaCard.module.scss';
import { Icon } from '../Icon';

export const DeleteAreaConfirmModal = ({
  onSubmit,
  onClose,
  name,
}: {
  onSubmit: () => void;
  onClose: () => void;
  name?: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.modal_root}>
      <div className={styles.modal_subheader}>
        <Icon name="alert" size="28px" />
        {t('GeofenceRemovingQuestion', { name })}
      </div>
      <div className={styles.modal_description}>{t('GeofenceRemovingDescription', { name })}</div>
      <div className={styles.buttons_group}>
        <Button variant="general" label={t('ButtonLabelDelete')} type="submit" onClick={onSubmit} />
        <Button variant="general" label={t('ButtonLabelDiscard')} type="reset" onClick={onClose} />
      </div>
    </div>
  );
};
